import { store } from "./repositories";

export default store;
